<template>
    <div class="mx-auto">
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos' && exibirPaginacao">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right" v-if="exibirPaginacao"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                    id="regrasPagamento"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    responsive
                    :busy="configTable.load"
                    show-empty
                    hover
                    bordered
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhum registro encontrado.</p>
                </template>
                <template v-slot:head(selecionar)="{ item }">
                    <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                </template>
                <template v-slot:cell(selecionar)="{ item }">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.numeroRequisicao)" @change="toggleCheck($event, item)" />
                </template>
                <template v-slot:head(1)="{ item }">
                    Número Requisição <i class="filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número Requisição', 'mascara', '', '#########', $event)"></i>
                </template>
                <template v-slot:cell(1)="{ item }">
                    <p class="text-center">
                        <a class="link" @click="abrirModalExtrato(item)">
                            {{ item.numeroRequisicao }}
                        </a>
                    </p>
                </template>
                <template v-slot:head(2)="{ item }">
                    Tipo Requisição <i class="filter" :class="!isEmpty(filtros.tipoRequisicacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Requisição', 'checkbox', dados.tiposRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(2)="{ item }">
                    {{ item.tabelaOrigem == 0 ? item.tipoRequisicao.nome + " - " + item.receita : item.receita }}
                </template>
                <template v-slot:head(3)="{ item }">
                    Processo <i class="filter" :class="!isEmpty(filtros.cnj) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Processo', 'mascara', '', 'cnj', $event)"></i>
                </template>
                <template v-slot:cell(3)="{ item }">
                    <p v-if="item.cnj.length == 1">
                        {{ item.cnj[0] }}
                    </p>
                    <p v-if="!item.abrirTodos && item.cnj.length > 1">
                        {{ item.cnj[0] }} <a class="link" @click="expandirOutros(item)">e outros</a>
                    </p>
                    <p v-for="cnj in item.cnj" v-if="item.abrirTodos && item.cnj.length > 1">
                        {{ cnj }}
                    </p>
                </template>
                <template v-slot:head(4)="{ item }">
                    CDA's <i class="filter" :class="!isEmpty(filtros.cda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDAs', 'mascara', '', '##########', $event)"></i>
                </template>
                <template v-slot:cell(4)="{ item }">
                  <p class="text-center" v-if="item.cdas.length == 0">
                    -
                  </p>
                  <span v-for="(cda, index) in item.cdas">
                    <span v-if="index > 0">, </span>
                    <a class="link" @click="abrirModalExtratoCda(cda.split('/')[0], cda.split('/')[1])">{{cda.split('/')[0]}}</a>
                  </span>
                </template>
                <template v-slot:head(5)="{ item }">
                    Devedor <i class="filter" :class="!isEmpty(filtros.contribuinte) || filtros.filtrarContribuinte == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(5)="{ item }">
                    {{ item.devedor }}
                </template>
                <template v-slot:head(6)="{ item }">
                    Data Emissão <i class="filter" :class="!isEmpty(filtros.dataEmissao) || filtros.filtrarDataEmissao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Emissão', 'data', '', null, $event)"></i>
                </template>
                <template v-slot:cell(6)="{ item }">
                    <p class="text-center">
                        {{ item.dataEmissao }}
                    </p>
                </template>
                <template v-slot:head(7)="{ item }">
                    Tipo Pagamento <i class="filter" :class="!isEmpty(filtros.tipoPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Pagamento', 'checkbox', dados.tiposPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(7)="{ item }">
                    {{ item.tipoPagamento }}
                </template>
                <template v-slot:head(8)="{ item }">
                    Forma Pagamento <i class="filter" :class="!isEmpty(filtros.formaPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Forma Pagamento', 'checkbox', dados.formasPagamento, null, $event)"></i>
                </template>
                <template v-slot:cell(8)="{ item }">
                    {{ item.formaPagamento }}
                </template>
                <template v-slot:head(9)="{ item }">
                    Valor <i class="filter" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor', 'numerico', '', null, $event)"></i>
                </template>
                <template v-slot:cell(9)="{ item }">
                    <p class="text-right" v-if="item.valor != null">
                        {{ item.valor | currency }}
                    </p>
                </template>
                <template v-slot:head(10)="{ item }">
                    Situação da Requisição
                    <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                       v-b-modal.modal-info-situacao
                       v-b-popover.hover.top="'Clique aqui para saber mais sobre Situação da Requisição'"></i>
                    <i class="filter" :class="!isEmpty(filtros.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação da Requisição', 'checkbox', dados.statusRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(10)="{ item }">
                    <p :style="'color: ' + item.cor">
                        {{ item.situacao }}
                    </p>
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos' && exibirPaginacao">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Requisições Encontradas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : resultado.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Requisições Selecionadas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="listarHistorico">
                                <i class="fas fa-edit"></i> Ver Todas Req.
                            </b-button>
                            <b-button class="ml-2" variant="primary" @click="exportar">
                                <i class="fa fa-table"></i> Exportar CSV
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>

        <b-modal
                ref="modal-info-situacao"
                id="modal-info-situacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Tipos de Situação da Requisição"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p><span style="color: #ffa500"><strong>Aguardando Aprovação:</strong></span> requisição de honorários gerada por usuário do perfil administrativo (estagiário ou servidor) e aguardando aprovação por algum procurador.</p>
                    <p><span style="color: #ffa500"><strong>Aguardando Validação:</strong></span> requisição de honorários com a forma de pagamento por transferência bancária e aguardando validação pelo GOFS e pelo tesoureiro do FEPGE.</p>
                    <p><span style="color: #ffa500"><strong>Pendente:</strong></span> requisição de honorários do tipo de pagamento à vista aguardando a confirmação de pagamento do boleto único ou do tipo de pagamento parcelamento aguardando a confirmação de pagamento do boleto da primeira parcela.</p>
                    <p><span style="color: #ffa500"><strong>Em dia:</strong></span> requisição de honorários do tipo de pagamento parcelamento com todas as parcelas vencidas pagas e ainda com parcelas a vencer.</p>
                    <p><span style="color: #ffa500"><strong>Atrasada:</strong></span> requisição de honorários do tipo de pagamento parcelamento com uma ou duas parcelas vencidas.</p>
                    <p><span style="color: #ff2e17"><strong>Cancelada:</strong></span> requisição de honorários do tipo de pagamento à vista com boleto único vencido e não pago, do tipo de pagamento parcelamento com o boleto da primeira parcela vencido e não pago ou cancelado por ação do usuário.</p>
                    <p><span style="color: #ff2e17"><strong>Rescindida:</strong></span> requisição de honorários do tipo de pagamento parcelamento rescindido após o registro de pagamento de uma ou mais parcelas ou rescindido por ação do usuário após o registro de pagamento de uma ou mais parcelas.</p>
                    <p><span style="color: #0073c0"><strong>Quitada:</strong></span> requisição de honorários do tipo de pagamento à vista com confirmação de pagamento ou do tipo de pagamento parcelamento com confirmação de pagamento de todas as parcelas.</p>
                    <p><span style="color: #0073c0"><strong>Encaminhada CES:</strong></span> requisição de honorários de titularidade da Caixa Especial de Sucumbência - CES encaminhada à CES para cobrança.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";

    export default {
    props: ['resultado', 'configTable', 'filtroComponente', 'filtros', 'loading', 'selecteds'],
    components: {CompBotaoExibirOcultarColuna},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            exibirPaginacao: false,
            showColunms: [],
            fields: [
                {
                    key: "selecionar",
                }
            ],
            dados: {
                formasPagamento: null,
                tiposPagamento: null,
                statusRequisicao: null,
                tiposRequisicao: [
                    {id: 1, nome: "Honorários de Ação Judicial"},
                    {id: 4, nome: "Honorários de EF - Base de Cálculo D.A. SEFA"},
                    {id: 3, nome: "Honorários de Protesto"},
                    {id: 0, nome: "Receita Diversa"},
                ]
            },
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.numeroRequisicao)) {
                        this.selecteds.push(el.numeroRequisicao);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.numeroRequisicao)) {
                        const index = this.selecteds.indexOf(el.numeroRequisicao);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.numeroRequisicao);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.numeroRequisicao);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        async obterColunasUsuario() {
            const funcionalidade = 'requisicoesUsuario';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },

        exportar() {
            this.$emit('exportar', 'requisicoesUsuario');
        },

        listarHistorico() {
            this.exibirPaginacao = true;
        },
        async listarFormaPagamento() {
            axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.formasPagamento = response.data
            })
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        async listarStatusRequisicao() {
            axios.get(`${this.urlApi}/v1/pesquisas/listarStatusRequisicao`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.statusRequisicao = response.data
            })
        },
        abrirModalExtrato(item) {
            this.$emit('abrirExtrato', item);
        },
        abrirModalExtratoCda(numeroCda, codOrgaoOrigemDivida) {
            this.$emit('abrirExtratoCda', numeroCda, codOrgaoOrigemDivida);
        },

        limparFiltros() {
            this.$emit('limparFiltros');
        },
        expandirOutros(item) {
            item.abrirTodos = true;
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();
        this.listarFormaPagamento();
        this.listarTiposPagamento();
        this.listarStatusRequisicao();
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
